module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor20.9e848f00.png";